import {Accordion, styled} from '@mui/material';

export const StyledAccordion = styled(Accordion)`
	border: none;
	box-shadow: none;
	border-radius: 8px;
	margin: 0;

	&::before {
		display: none;
	}

	.MuiAccordionSummary-root {
		min-height: auto;
		height: 30px;
		gap: 8px;
	}

	.MuiAccordionSummary-root > div.MuiAccordionSummary-content {
		margin: 0;
		justify-content: end;

		h6 {
			line-height: initial;
		}
	}
`;
